export const saveEventToAnalytics = ({ eventName, parameters = null }) => {
  if (typeof window !== "undefined") {
    try {
      window.gtag("event", eventName, { send_to: [process.env.REACT_APP_GA4_ID], ...parameters });
    } catch (error) {
      console.log(error);
    }
  }
};
